<template>
    <v-btn prepend-icon="mdi-merge"
           class="mr-1"
           @click="openDialog"
           variant="flat"
           :loading="loading"
           color="grey-lighten-2">
        Merge Colour
    </v-btn>
    <v-dialog v-model="showMerge"
              fullscreen
              persistent
              :scrim="false">
        <v-card>
            <v-toolbar dark
                       color="primary">
                <v-toolbar-title><v-icon icon="mdi-merge"></v-icon> Merge Colour</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon
                       dark
                       @click="showMerge = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <p>Search for a colour to merge with this colour below. Select which colour of the two you will keep. <strong>The colour not kept will be deleted.</strong></p>
                <p>PLEASE ENSURE YOU UPDATE XERO WITH THE CORRECT COLOUR DETAILS.</p>
                <v-radio-group v-model="masterColourId">
                    <div class="mt-2 pt-2 bg-blue-lighten-4 pa-2">
                        <div class="text-caption">THIS COLOUR</div>
                        <h3>{{ colour.code }} - {{ colour.name }}</h3>
                        <v-radio label="Keep this colour?"
                                 :value="colour.id"></v-radio>
                    </div>
                    <div class="mt-2 pt-2 bg-amber-lighten-4 pa-2">
                        <div class="text-caption">MERGE COLOUR</div>
                        <v-combobox v-model="mergeColour"
                                    label="Colour"
                                    density="compact"
                                    :loading="coloursSelectLoading"
                                    :items="filteredColoursSelect"
                                    hide-details
                                    item-title="selectName"></v-combobox>
                        <router-link v-if="mergeColour" :to="'/'+$constants.entities.Colour.ROUTE+mergeColour.id" @click.stop target="_blank">View Colour</router-link>
                        <v-radio label="Keep this colour?"
                                 :disabled="!mergeColour"
                                 :value="mergeColour ? mergeColour.id : null"></v-radio>
                    </div>
                </v-radio-group>
                <v-alert v-if="errors.length > 0" type="warning">
                    <ul>
                        <li v-for="error in errors" :key="error">{{ error }}</li>
                    </ul>
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn :loading="saving"
                       color="primary"
                       prepend-icon="mdi-floppy"
                       @click="saveMerge"
                       :disabled="errors.length > 0"
                       dark>
                    SAVE
                </v-btn>
                <v-btn dark @click="showMerge = false" :disabled="saving">
                    CANCEL
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped>

</style>
<script>
    function initialState() {
        return {
            loading: false,
            saving: false,
            showMerge: false,
            masterColourId: null,
            mergeColour: null
        };
    }
    import { mapActions, mapState } from "vuex";
    export default {
        name: "MergeColour",
        data: function () {
            return initialState();
        },
        props: {
            colour: Object
        },
        methods: {
            ...mapActions([
                "showErrorSnack",
                "showSuccessSnack",
                "loadSelectColours",
                "reloadEntities"
            ]),
            openDialog() {
                this.showMerge = true;
                this.loadData();
            },
            loadData() {
                this.loadSelectColours();
            },
            saveMerge() {
                this.$confirm(
                    {
                        message: 'Are you sure you want to merge these colours? This will merge all notes, stock transactions and jobs and set the one you are not keeping as deleted.',
                        disableKeys: false,
                        auth: false,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        },
                        callback: confirm => {
                            if (confirm) {
                                this.saving = true;
                                this.$api.post('colours/merge', {
                                    masterColourId: this.masterColourId,
                                    mergeColourId: this.masterColourId === this.colour.id ? this.mergeColour.id : this.colour.id
                                })
                                    .then(res => {
                                        this.reloadEntities();
                                        this.saving = false;
                                        this.showSuccessSnack('Colours merged successfully.');
                                        this.showMerge = false;
                                        this.masterColourId = null;
                                        this.mergeColour = null;
                                    })
                                    .catch(error => {
                                        this.saving = false;
                                        this.showErrorSnack('There was an error merging colours.');
                                    });
                            }
                        }
                    }
                )
            }
        },
        computed: {
            ...mapState({
                coloursSelect: (state) => state.colours.coloursSelect,
                coloursSelectLoading: (state) => state.colours.coloursSelectLoading,
            }),
            filteredColoursSelect() {
                if (!this.coloursSelect) return [];
                return this.coloursSelect.filter(c => c.id !== this.colour.id);
            },
            errors() {
                let result = [];
                if (!this.mergeColour) {
                    result.push("Select a colour to merge this colour with.")
                }
                if (!this.masterColourId) {
                    result.push("Tick which of the two colours to keep.")
                }

                return result;
            }
        }
    };
</script>
